
import Vue from 'vue';
import Axios from 'axios';
import ModuleFields from '@/components/generic/ModuleFields.vue';
import { ApiData } from '@/plugins/apiData';
import { FlowData } from '@/plugins/customData';
import { EventBus } from '@/plugins/eventBus';

export default Vue.extend({
  name: 'FlowShell',
  components: {
    ModuleFields,
  },
  data: () => ({
    flowData: {} as FlowData,
    flowName: '',
    active: 0,
    single: false,
    domain: window.location.origin,
  }),
  watch: {
    $route(to, from) {
      this.flowData = {} as FlowData;
      this.active = 0;
      this.single = false;
      this.getFlow();
    },
  },
  props: {
    hideMods: {
      type: Boolean,
      default: false,
      required: false,
    },
    bread: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    removeUnderScores(txt: string): string {
      return txt.replace(/_/gi, ' ');
    },
    getFlow(): void {
      this.flowName = this.$route.params[0];
      const flows = new ApiData({ command: 'get_flow', id: this.$route.params.name });
        // Axios.get(`http://localhost:5000/flow/${this.flowName}`)
      flows.send()
      .then((result) => {
          this.flowData = result.data;
          if (result.data.modules) {
            this.single = result.data.modules.length > 1;
          }
      })
      .catch((reason) => {
          EventBus.$emit('message', { context: 'error', text: reason });
      });
    },
    next(): void {
        const active = parseInt(this.active.toString(), 10);
        this.active = (active < this.flowData.modules.length ? active + 1 : 0);
    },
  },
  mounted() {
    this.getFlow();
  },
});
